import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import Helmet from 'react-helmet'
// @ts-ignore
import { getConfig } from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {
  useCountryData,
  useChat,
  useCookie,
  useEffectSkipFirst
} from 'msp-integrations'
import { EventsEmitter, Events } from 'msp-components'
import React from 'react'

export type ChatTypes = {
  WebOriginCountry: string
  Brand?: string
  showAfterSeconds?: number
}

const Chat = ({
  WebOriginCountry,
  Brand = 'Darq',
  showAfterSeconds = 5
}: ChatTypes) => {
  const { getCookieAllowedById } = useCookie()
  const { isInitialized, setIsInitialized } = useChat()
  const { jasminChatDetails } = getConfig()
  const i18n = useCountryData()
  const { formatMessage } = useIntl()

  const isSalesforceAllowed = getCookieAllowedById('s291') // CONSENTS['s291'] = 'salesforce'

  // @ts-ignore
  useEffect(() => {
    if (!isInitialized && isSalesforceAllowed) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      const timer = setTimeout(createChat, showAfterSeconds * 1000)
      return () => {
        clearTimeout(timer)
      }
    }
  }, [isSalesforceAllowed])

  useEffectSkipFirst(isSalesforceAllowed, () => {
    if (!isSalesforceAllowed) {
      location.reload()
    }
  })

  const initChat = (): void => {
    try {
      // @ts-ignore
      const { embeddedservice_bootstrap } = window
      if (embeddedservice_bootstrap) {
        embeddedservice_bootstrap.settings.language = i18n.locale?.split('_')[0]

        embeddedservice_bootstrap.init(
          jasminChatDetails.SVCPublicId,
          jasminChatDetails.eswLiveAgentDevName,
          jasminChatDetails.communityURL,
          {
            scrt2URL: jasminChatDetails.scrt2URL
          }
        )
      }
      window.addEventListener('onEmbeddedMessagingWindowMaximized', (e) => {
        EventsEmitter.dispatch(Events.OPEN_CHAT, [])
      })
      window.addEventListener('onEmbeddedMessagingWindowMinimized', (e) => {
        EventsEmitter.dispatch(Events.CLOSE_CHAT, [])
      })
      window.addEventListener('onEmbeddedMessagingWindowClosed', (e) => {
        EventsEmitter.dispatch(Events.CLOSE_CHAT, [])
      })
    } catch (error) {
      console.error('Error loading Embedded Messaging: ', error)
    }
  }

  const createChat = () => {
    // @ts-ignore
    if (typeof window !== 'undefined' && !window.embeddedservice_bootstrap) {
      const s = window.document.createElement('script')
      s.setAttribute('type', 'text/javascript')
      s.setAttribute('src', jasminChatDetails.bootstrapURL)
      s.setAttribute('data-cmp-vendor', 's291')
      s.onload = () => {
        setIsInitialized(true)
        initChat()
      }
      window.document.body.appendChild(s)
    } else {
      initChat()
    }
  }

  return (
    <Helmet>
      <meta name='referrer' content='origin' />
    </Helmet>
  )
}

export default Chat
